export default __webpack_public_path__ + "a4d6e7a069640dcc641be851acbeeac5.png";